import { createSelector } from "reselect";
import constants from "../../utils/constants";
import { name } from "../App";
import moment from "moment";

export const getModelSelector = state => state[name];

export const smartPaymentModeSelector = createSelector(
  getModelSelector,
  model => model.get("reservation") && model.get("reservation").get("deferred")
);
